<template>
    <div class="modal fade" ref="alunoModal">
        <div class="modal-dialog modal-md" role="document">
            <div class="modal-content p-3">
                <div class="modal-header">
                    <h5 class="modal-title" id="AlunoModalLabel">Dados do aluno</h5>
                    <button class="close" type="button" @click="closeModal()"><span aria-hidden="true">&times;</span></button>
                </div>
                <div class="modal-body">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-8">
                                <strong>Aluno: </strong> {{ aula.aluno }}
                            </div>
                            <div class="col-md-4">
                                <strong>Renach: </strong> {{ aula.renach }}
                            </div>
                        </div>
                        <div class="row pt-3 ">
                            <div class="col-md-8">
                                <strong>CPF: </strong> {{ aula.cpf }}
                            </div>
                            <div class="col-md-4">
                                <strong>Turno: </strong> {{ aula.turno }}
                            </div>
                        </div>
                        <div class="row pt-3 pb-3 border-bottom">
                            <div class="col-md-8">
                                <strong>Categoria: </strong> {{ aula.categoria }}
                            </div>
                        </div>
                        <div class="row pt-3">
                            <div class="col-md-12">
                                <SelectIconGroup iconInput="fa-vehicle" idInput="id_veiculo" labelInput="Veículo" :optionsInput="veiculos"
                                :optionSelected="aula.veiculoId" />
                            </div>
                        </div>
                        <div class="row border-bottom">
                            <div class="col-md-12">
                                <SelectIconGroup iconInput="fa-teacher" idInput="id_instrutor" labelInput="Instrutor" :optionsInput="instrutores"
                                :optionSelected="aula.instrutorId" />
                            </div>
                        </div>
                        <!-- <div class="row pt-3">
                            <div class="col-md-4 offset-md-2">
                                <label for="horario_inicio" class="form-control">Hodômetro incial: </label>
                                <input type="text" v-model="aula.hodometro_inicial" readonly disabled>
                            </div>
                            <div class="col-md-4">
                                <label for="horario_fim" class="form-control" >Hodômetro final: </label>
                                <input type="text" v-model="aula.hodometro_final" readonly disabled>
                            </div>
                        </div> -->
                        <div class="row pt-3">
                            <div class="col-md-4 offset-md-2">
                                <label for="horario_inicio" class="form-control">Inicio da aula: </label>
                                <input type="time" name="t_inicio" id="horario_inicio" v-model="aula.inicio_real">
                            </div>
                            <div class="col-md-4">
                                <label for="horario_fim" class="form-control" >Fim da aula: </label>
                                <input type="time" name="t_fim" id="horario_fim" v-model="aula.fim_real">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-secondary btn-sm" @click="closeModal()" :disabled="loading">Fechar</button>
                    <button class="btn btn-primary btn-sm" type="button" @click="alterarAula()" :disabled="loading">Salvar</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import SelectIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/SelectIconGroup'
import urlApi from '@/router/urlApiV2'

export default {
    components: {
        SelectIconGroup,
    },
    props: {
        show: Boolean,
        aula: Object,
        instrutores: Array,
        veiculos: Array
    },
    data() {
        return {
            loading: false,
        }
    },
    created() {

    },
    methods: {
        alterarAula() {
            this.loading = true
            let data = {
                aula: this.aula.aulaPraticaId,
                anotacaoPratica: this.aula.anotacaoPraticaId,
                instrutor: document.getElementById('id_instrutor').value,
                inicio: this.aula.inicio_real,
                fim: this.aula.fim_real,
                veiculo: document.getElementById('id_veiculo').value,
                schema: this.aula.schema,
            }
            this.$http.post(urlApi + '/dashboard/aulas/praticas/atualizarenvio', data)
            .then(response => {
                if(response.data.success) {
                    Vue.toasted.show('Aula alterada.', {
                        icon: 'fa-check',
                        position: 'top-right',
                        duration: 5000,
                        fullWidth: false
                    })
                    this.loading = false
                    this.closeModal();
                } else {
                    Vue.toasted.show('Erro na alteração da aula', {
                        icon: 'fa-info',
                        position: 'top-right',
                        duration: 5000,
                        fullWidth: false
                    })
                    this.loading = false
                }
            })
        },
        closeModal() {
            this.$emit('close')
        }, 
    }
}
</script>
<style scoped lang="scss">
.modal-footer {
    button:disabled {
        cursor: wait;
    }
}
</style>
